import Container from '@ui/container/container';
import { ICONS } from '@ui/icons/types';
import { EPermissions } from '@/types/permissions.types';
import useHasPermission from '@/utils/authentication/use-has-permission';
import OptionalComponent from '@ui/optional-component/optional-component';
import Icon from '@ui/icons/icon';
import Text from '@ui/text/text/text';
import Button from '@ui/buttons/button/button';
import getThemeColorCSSVariable from '@/utils/colors/get-theme-color-css-variable';
import { EColorVariablesV2 } from '@/types/theme-packs.types';
import getThemeColorContrastCSSVariable from '@/utils/colors/get-theme-color-contrast-css-variable';

type TAudiencesAddButtonProps = {
  onAddClick?: () => void;
  canEdit?: boolean;
};

const AudiencesAddButton = ({ onAddClick, canEdit = true }: TAudiencesAddButtonProps) => {
  const { hasPermission } = useHasPermission({
    allowedRoles: [EPermissions.GroupAdmin],
  });

  return (
    <Container data-component="AddAudienceButton" className="flex ai-center jc-flex-end gap-1">
      <OptionalComponent display={hasPermission && canEdit}>
        <Button
          height="32px"
          padding="0 16px"
          clear
          className="flex ai-center jc-center"
          borderRadius="100px"
          onClick={onAddClick}
          backgroundColor={getThemeColorCSSVariable(EColorVariablesV2.primary)}
        >
          <div className="flex ai-center jc-center gap-8">
            <Icon
              name={ICONS.ADD}
              size={16}
              color={getThemeColorContrastCSSVariable(EColorVariablesV2.buttonText, EColorVariablesV2.primary)}
            />
            <Text
              className="L1"
              color={getThemeColorContrastCSSVariable(EColorVariablesV2.buttonText, EColorVariablesV2.primary)}
            >
              Add
            </Text>
          </div>
        </Button>
      </OptionalComponent>
    </Container>
  );
};

export default AudiencesAddButton;
